import { AppMenuDto } from './app.model';
// defaultModule : 'pages'
export const mappingMenus = [
  {
    path: 'tariff',
    iconClass: 'audit',
    lookupFieldName: 'portName',
    lookupFieldCode: 'typeOfCallName',
    features: { attachments: { single: true }, comments: true },
    crudAction: {
      list: 'pages/tariff',
      read: 'pages/tariff',
      create: 'pages/tariff',
      update: 'pages/tariff',
    },
    requiredPolicy: 'Mappings.Tariffs',
  },

  {
    path: 'ctm-tariff',
    entity: 'customer-tariff',
    iconClass: 'dollar',
    lookupFieldName: 'customerName',
    lookupFieldCode: 'portName',
    features: { attachments: { single: true }, comments: true },
    crudAction: {
      list: 'pages/ctm-tariff',
      read: 'pages/ctm-tariff',
      create: 'pages/ctm-tariff',
      update: 'pages/ctm-tariff',
    },
    requiredPolicy: 'Mappings.Tariffs',
  },

  {
    path: 'customer-tariff',
    iconClass: 'team',
    lookupFieldName: 'customerName',
    lookupFieldCode: 'portName',
    features: { attachments: { single: true }, comments: true },
    crudAction: {
      list: 'pages/customer-tariff',
      read: 'pages/customer-tariff',
      create: 'pages/customer-tariff',
      update: 'pages/customer-tariff',
    },
    requiredPolicy: 'Mappings.Tariffs',
  },

  {
    path: 'port-service-section',
    lookupFieldName: 'portName',
    lookupFieldCode: 'typeOfCallName',
    columns: ['portName', 'typeOfCallName'],
    requiredPolicy: 'Mappings.TaskMappings',
    crudAction: {
      list: 'pages/port-service-section',
      read: 'pages/port-service-section',
      create: 'pages/port-service-section',
      update: 'pages/port-service-section',
    },
  },

  {
    path: 'configuring-sop',
    lookupFieldName: 'portName',
    lookupFieldCode: 'typeOfCallName',
    columns: ['portName', 'typeOfCallName'],
    requiredPolicy: 'Mappings.ConfiguringSOPs',
    crudAction: {
      list: 'pages/configuring-sop',
      read: 'pages/configuring-sop',
      create: 'pages/configuring-sop',
      update: 'pages/configuring-sop',
    },
  },
] as AppMenuDto[];
